import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=f276622c&scoped=true&"
import script from "./goods-info.vue?vue&type=script&lang=js&"
export * from "./goods-info.vue?vue&type=script&lang=js&"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=f276622c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f276622c",
  null
  
)

export default component.exports